// apps/web/src/catalog/leadSources.queries.ts
//
// Shared lead-source catalog picker query + key, extracted for #1752 so
// call-center-admin does not import the crm feature. The hook and the
// `['lead-sources']` query-key value are moved byte-identically out of
// `features/crm/queries.ts`; the key value is unchanged so the crm mutation
// invalidators (which now import `LEAD_SOURCES_QK` back from here) keep
// invalidating the same cache.
import { useQuery } from '@tanstack/react-query';
import type { LeadSourceListQuery } from '@magimp/shared';
import { listLeadSources } from '../api/lead-sources.js';

export const LEAD_SOURCES_QK = ['lead-sources'] as const;

export function useLeadSources(query: Partial<LeadSourceListQuery> = {}) {
  return useQuery({
    queryKey: [...LEAD_SOURCES_QK, query.includeArchived ?? false],
    queryFn: () => listLeadSources(query),
  });
}
